import React from "react";
import Select from "react-select";
import i18next from "i18next";

const CatalanFlag = () => (
	<svg
		width="20"
		height="14"
		viewBox="0 0 20 14"
		xmlns="http://www.w3.org/2000/svg"
		style={{ display: "block", borderRadius: "2px" }}
	>
		{[...Array(9)].map((_, i) => (
			<rect
				key={i}
				x="0"
				y={(i * 14) / 9}
				width="20"
				height={14 / 9 + 0.1}
				fill={i % 2 === 0 ? "#FCDD09" : "#DA121A"}
			/>
		))}
	</svg>
);

const FLAG = {
	es: <span style={{ fontSize: "16px", lineHeight: 1 }}>🇪🇸</span>,
	en: <span style={{ fontSize: "16px", lineHeight: 1 }}>🇬🇧</span>,
	ca: <CatalanFlag />,
};

const formatOptionLabel = ({ value, label }) => (
	<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
		{FLAG[value]}
		<span>{label}</span>
	</div>
);

const getOptions = () => [
	{ value: "es", label: i18next.t("employee.localeEs") },
	{ value: "en", label: i18next.t("employee.localeEn") },
	// { value: "ca", label: i18next.t("employee.localeCa") }, // TODO: descomentar cuando el diccionario ca esté completo
];

const LocaleSelect = ({ value, onChange, disabled, className }) => {
	const options = getOptions();
	const selected = options.find((o) => o.value === (value || "es")) || options[0];

	return (
		<Select
			options={options}
			value={selected}
			onChange={(opt) => onChange(opt.value)}
			formatOptionLabel={formatOptionLabel}
			isDisabled={disabled}
			isSearchable={false}
			classNamePrefix="locale-select"
			className={className}
			menuPortalTarget={document.body}
			styles={{
				menuPortal: (base) => ({ ...base, zIndex: 9999 }),
				control: (base) => ({ ...base, minHeight: "38px" }),
			}}
		/>
	);
};

export default LocaleSelect;
